import { useTranslation } from 'react-i18next';

import { Spinner } from '@/components/atoms/Spinner';
import PageLayout from '@/components/Layout/PageLayout';
import { usePermissions } from '@/contexts/auth';
import { useCage, useCageName, useCageTimezone } from '@/contexts/cage';
import { usePenCohortFishGroup } from '@/contexts/pen-cohort-context';
import { useCommitImageFeedback } from '@/domain/imageFeedback';
import { useGetWelfareImages } from '@/domain/images';
import CageWelfareWoundDetectionsPageContent from '@/routes/Client/Cage/pages/CageWelfare/CageWelfareWounds/pages/CageWelfareWoundDetections/CageWelfareWoundDetectionsPageContent';
import type { CagePageInterface } from '@/routes/Client/Cage/utils/cage-pages-interface';
import { MERGED_WELFARE_IMAGES_TYPE } from '@/utils/welfareImageHelpers';

function CageWelfareWoundDetectionsContainer({ cageId }: CagePageInterface) {
    const { t } = useTranslation();
    const { isOptoScaleAdmin } = usePermissions();

    const { loading: cageLoading } = useCage();
    const timezone = useCageTimezone();
    const cageName = useCageName();

    const onCommitImageFeedback = useCommitImageFeedback({ cageId });

    const imagesFishGroup = usePenCohortFishGroup();
    const { data: imagesdata, isLoading: imagesdataLoading } = useGetWelfareImages(
        cageId,
        { type: MERGED_WELFARE_IMAGES_TYPE },
        { emptyWhileLoading: true, keepPreviousData: true, fishGroup: imagesFishGroup }
    );

    const loading = cageLoading || imagesdataLoading;

    return (
        <PageLayout title={cageName} subtitle={t('cageWelfare.wounds.woundDetections')}>
            {loading && <Spinner size="lg" fullScreen />}
            {!loading && (
                <CageWelfareWoundDetectionsPageContent
                    imagesData={imagesdataLoading ? null : imagesdata}
                    isOptoScaleAdmin={isOptoScaleAdmin}
                    onCommitFalseDetection={onCommitImageFeedback}
                    cageId={cageId}
                    timezone={timezone}
                />
            )}
        </PageLayout>
    );
}

export default CageWelfareWoundDetectionsContainer;
export { CageWelfareWoundDetectionsContainer };
